export default __webpack_public_path__ + "static/backstagesupport-51-aca68d838ee73cad8bd2e81833684485.png";